export default "__VITE_ASSET__Bi8EfFKb__"